import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import routes from './routes.json';
import HomePage from './pages/HomePage';
import AboutUs from './pages/AboutUs';
import PrincipalMessage from './pages/PrincipalMessage';
import CoreValues from './pages/CoreValues';
import SchoolWideInitiatives from './pages/SchoolWideInitiatives';
import AfterSchoolEnrichment from './pages/AfterSchoolEnrichment';
import Partnerships from './pages/Partnerships';
import Wediko from './pages/Wediko';
import Contact from './pages/Contact';
import Calendar from './pages/Calendar';
import SchoolLeadershipTeam from './pages/SchoolLeadershipTeam';
import StaffDirectory from './pages/StaffDirectory';
import Curriculum from './pages/Curriculum';
import PreK from './pages/grades/PreK';
import Kindergarten from './pages/grades/Kindergarten';
import Grade1 from './pages/grades/Grade1';
import Grade2 from './pages/grades/Grade2';
import Grade3 from './pages/grades/Grade3';
import Grade4 from './pages/grades/Grade4';
import Grade5 from './pages/grades/Grade5';

// Scraped data from P.S. 155 website
const scrapedData = {
  schoolName: "P.S. 155 M",
  mission: "Where Panthers Grow With Passion, Purpose and East Harlem Pride",
  address: "319 East 117th Street, New York, NY 10035",
  instagram: "@ps155d4",
  twitter: "@ps155d4"
};

// Single source of truth for routing lives in src/routes.json, which also drives
// scripts/prerender.mjs. To ADD a page: create the component, import it above,
// add it to this registry, and add an entry to src/routes.json. To REMOVE a page:
// delete all four (component file, import, registry entry, routes.json entry).
// Registry values are render functions so per-route props (e.g. scrapedData on
// HomePage) are preserved exactly.
const registry = {
  HomePage: () => <HomePage scrapedData={scrapedData} />,
  AboutUs: () => <AboutUs />,
  PrincipalMessage: () => <PrincipalMessage />,
  CoreValues: () => <CoreValues />,
  Curriculum: () => <Curriculum />,
  PreK: () => <PreK />,
  Kindergarten: () => <Kindergarten />,
  Grade1: () => <Grade1 />,
  Grade2: () => <Grade2 />,
  Grade3: () => <Grade3 />,
  Grade4: () => <Grade4 />,
  Grade5: () => <Grade5 />,
  SchoolWideInitiatives: () => <SchoolWideInitiatives />,
  AfterSchoolEnrichment: () => <AfterSchoolEnrichment />,
  Partnerships: () => <Partnerships />,
  Wediko: () => <Wediko />,
  Contact: () => <Contact />,
  Calendar: () => <Calendar />,
  SchoolLeadershipTeam: () => <SchoolLeadershipTeam />,
  StaffDirectory: () => <StaffDirectory />,
};

function App() {
  return (
    <Router>
      <Routes>
        {routes.map(({ path, component }) => {
          const render = registry[component];
          return render ? <Route key={path} path={path} element={render()} /> : null;
        })}
      </Routes>
    </Router>
  );
}

export default App;
